export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatDateLabel(value: string): string {
  const parts = value.split(" ");
  return parts.length > 1 ? parts[1] : value;
}

export function formatDateDay(value: string): string {
  const parts = value.split(" ");
  return parts.length > 1 ? parts[0] : value;
}

export function readingTime(paragraphs: string[]): string {
  const chars = paragraphs.join("").length;
  const minutes = Math.max(1, Math.round(chars / 400));
  return `${minutes} 分钟`;
}